var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      on: {
        close: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
        _c("h4", [_vm._v("Reply to Customer Review")])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal-body-scroll",
          attrs: { slot: "body" },
          slot: "body"
        },
        [
          _c("div", { staticClass: "row review-job-info" }, [
            _c("div", { staticClass: "col-md-12 text-center mb-3" }, [
              _c("p", [
                _vm._v(
                  "\n          You are about to reply to the Customer Review shown below. Once you add your reply, it will be shared on the website.\n        "
                )
              ]),
              _vm._v(" "),
              _vm.rating.body.length > 300
                ? _c("p", { attrs: { title: _vm.rating.body } }, [
                    _vm._v(_vm._s(_vm.rating.body.slice(0, 300) + " ..."))
                  ])
                : _c("p", [_vm._v(_vm._s(_vm.rating.body))])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-md-12 text-center review-container-reply mt-4"
              },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between comment-heading pt-1 pr-1"
                    },
                    [
                      _c("label", [_vm._v("Reply")]),
                      _vm._v(" "),
                      _vm.reply.length < 100
                        ? _c("span", { staticClass: "review-body-length" }, [
                            _vm._v("min " + _vm._s(_vm.remainingCount))
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.reply,
                        expression: "reply"
                      }
                    ],
                    staticClass:
                      "form-control w-100 border-0 bg-transparent review-comment",
                    staticStyle: { "min-height": "250px" },
                    attrs: { minlength: "100" },
                    domProps: { value: _vm.reply },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.reply = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "rating" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex align-items-center mt-3" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary modal-done w-full",
                      attrs: {
                        disabled: _vm.reply.length < 100 || _vm.loading
                      },
                      on: { click: _vm.saveReply }
                    },
                    [
                      _vm._v("\n            Reply\n            "),
                      _vm.loading
                        ? _c("div", { staticClass: "ld ld-ball ld-flip" })
                        : _vm._e()
                    ]
                  )
                ])
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb05b2a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb05b2a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/modals/CompanyRatingReplyModal.vue
// module id = null
// module chunks = 